'use client';

import { useRef } from 'react';
import { Grid, Picture, Tile } from '@petsmart-ui/sparky';
import { trackContentfulClick, trackTilesClicks } from '@libs/analytics';
import { propsImagesItems } from '../../utils/propsImagesItems';
import type { Tile6UpProps } from './types';
import { BuildContextProvider } from '../../providers';

export default function Tile6UpMultirow({
    header,
    variant,
    tiles,
    pathname,
}: Tile6UpProps) {
    const grid = useRef<HTMLDivElement>(null);

    const getTileRow = (tile: HTMLAnchorElement) => {
        if (!grid.current) {
            return null;
        }

        const tileTop = tile.getBoundingClientRect().top;
        const tileHeight = tile.getBoundingClientRect().height;

        const gridTop = grid.current.getBoundingClientRect().top ?? 0;

        return Math.ceil((tileTop - gridTop) / tileHeight);
    };

    const handleTileClick =
        (title: string, index: number, link: string, internalTitle: string) =>
        ({ currentTarget }: React.MouseEvent<HTMLAnchorElement>) => {
            const row = getTileRow(currentTarget);
            trackContentfulClick({
                position: index + 1,
                linkText: title,
                linkUrl: link,
                promoTitle: header ?? '',
                promoVariant: `Tile 6up - ${variant}`,
                promoOrigin: pathname || '',
                promoDesc: internalTitle,
                promoType: `Tile 6up - ${variant}`,
            });
            if (row) {
                trackTilesClicks({
                    variant,
                    header: header ?? '',
                    title,
                    position: index,
                    row,
                });
            }
        };

    return (
        <BuildContextProvider>
            <div ref={grid}>
                <Grid
                    data-testid="multirow-component-test-id"
                    variant="3-6up"
                    gridItemWrap="center"
                >
                    {tiles?.map(
                        (
                            { image, title, link, sysId, internalTitle },
                            index
                        ) => {
                            const {
                                remoteMobileImageUrl,
                                webAltText,
                                remoteDesktopImageUrl,
                            } = image || {};

                            return (
                                <Grid.Item key={sysId}>
                                    <Tile
                                        onClick={handleTileClick(
                                            title,
                                            index,
                                            link?.webUrl || '',
                                            internalTitle || ''
                                        )}
                                        title={title}
                                        href={link?.webUrl}
                                        alignText="center"
                                    >
                                        <Picture
                                            items={propsImagesItems(image)}
                                            imgSrc={
                                                remoteMobileImageUrl ||
                                                remoteDesktopImageUrl ||
                                                ''
                                            }
                                            imgAlt={webAltText ?? ''}
                                        />
                                    </Tile>
                                </Grid.Item>
                            );
                        }
                    )}
                </Grid>
            </div>
        </BuildContextProvider>
    );
}
